import { MarketAggregatesState, ModelRun } from './types';
import {
  toggleModelSelectionAction,
  updateModelRunsAction,
  resetAllSelectionsAction,
} from './actions';

export const useModelStateOperations = (
  setState: React.Dispatch<React.SetStateAction<MarketAggregatesState>>,
) => {
  const toggleModelSelection = (modelId: string) => {
    setState((prevState) => toggleModelSelectionAction(prevState, modelId));
  };

  const updateModelRuns = (modelId: string, runs: ModelRun[]) => {
    setState((prevState) => updateModelRunsAction(prevState, modelId, runs));
  };

  const resetAllSelections = () => {
    setState((prevState) => resetAllSelectionsAction(prevState));
  };

  const setWeightType = (weightType: 'population' | 'wind_capacity' | 'solar_capacity') => {
    setState((prevState) => ({
      ...prevState,
      weightType,
      loading: true,
      error: null,
    }));
  };

  const setMaxLeadTimeHours = (hours: number) => {
    setState((prevState) => ({
      ...prevState,
      maxLeadTimeHours: hours,
    }));
  };

  return {
    toggleModelSelection,
    updateModelRuns,
    resetAllSelections,
    setWeightType,
    setMaxLeadTimeHours,
  };
};
